module.exports = __webpack_public_path__ + "media/9_4.afe2ad1b.wav";